// * Import required libraries
import { useContext, useEffect } from "react";

// * Import contexts
import { ThemeContext } from "../../contexts/ThemeContext";

// * import lib component
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

// * Import custom components
import LayoutBottom from "../../layouts/LayoutBottom/LayoutBottom";
import SigviewTypography from "../../components/Common/SigviewTypography";

// * Import styles
import signInImage from "../../../assets/images/signinImg.svg";
import SigviewIcon from "../../components/Common/SigviewIcon";
import { useHistory, useLocation } from "react-router";

// * Define style functions
const makeSigviewStyles = (...args) => {
  const [themeColors, customStyle] = args;
  const useStyles = makeStyles({
    root: {
      height: "100%",
      width: "100%",
      display: "flex",
    },
    leftPanel: {
      width: "50%",
      height: "100%",
      display: "inline-block",
    },
    rightPanel: {
      width: "50%",
      height: "100%",
      display: "inline-block",
    },
    errorTextBox: {
      display: "flex",
      paddingBottom: " 5px",
    },
    signInImageContainer: {
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    sigmoidLogoContainer: {
      height: "50px",
      width: "100px",
      padding: "50px",
      cursor: "pointer",
    },
    mainSignInContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "calc(100% - 50px)",
    },
    mainSignInFormRow: {
      padding: "10px",
      width: "350px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
    },
  });
  return useStyles;
};
function SignInSSOError(props = {}) {
  const { ssoSignInErrorMessage = "Something went wrong" } = props;
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];
  const useSigviewStyles = makeSigviewStyles(themeColors);
  const classes = useSigviewStyles();

  const location = useLocation();
  const history = useHistory();

  // * Define required side effects
  // This makes sure that while this page is routed url doesnot changes
  useEffect(() => {
    const pathname = location.pathname;
    if (pathname !== "/sso/loginErrorMsg") {
      history.push("/sso/loginErrorMsg");
    }
  }, []);
  const commonChildrenProps = {
    classes,
    ssoSignInErrorMessage,
  };
  const SignInImage = (props = {}) => {
    const { classes } = props;
    return (
      <Box className={classes.signInImageContainer}>
        <img src={signInImage} alt="Sign In" width="80%" height="80%" />
      </Box>
    );
  };

  const SSOErrorMgs = (props = {}) => {
    const { classes, ssoSignInErrorMessage = "" } = props;
    return (
      <Box className={classes.mainSignInContainer}>
        <Box>
          <SigviewTypography
            variant="pLargest"
            style={{ padding: "10px 10px 30px 10px" }}
          >
            Connection Failed
          </SigviewTypography>

          <Box className={classes.errorTextBox}>
            <Box>
              <SigviewIcon
                className={`material-icons-round`}
                iconName="fiber_manual_record"
                style={{
                  padding: "0px 5px 0px 0px",
                }}
              />
            </Box>
            <Box>
              <SigviewTypography
                variant="pMedium"
                style={{
                  lineHeight: "16px",
                  textAlign: "left",
                  width: "350px",
                  height: "auto",
                  fontSize: "12px",
                }}
              >
                {ssoSignInErrorMessage}
              </SigviewTypography>
            </Box>
          </Box>
          <Box className={classes.errorTextBox}>
            <Box>
              <SigviewIcon
                className={`material-icons-round`}
                iconName="fiber_manual_record"
                style={{
                  padding: "0px 5px 0px 0px",
                }}
              />
            </Box>
            <Box>
              <SigviewTypography
                variant="pMedium"
                style={{
                  lineHeight: "16px",
                  textAlign: "left",
                  width: "350px",
                  height: "auto",
                  fontSize: "12px",
                }}
              >
                Please try relogging back from the OpenXSelect portal
              </SigviewTypography>
            </Box>
          </Box>
          <Box>
            <a
              href="https://oa-ui.devint.gcp.openx.org"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <SigviewIcon
                className={`material-icons-round`}
                iconName="autorenew"
                style={{
                  padding: "20px 0px 0px 0px",
                  fontSize: "35px",
                  cursor: "pointer",
                }}
              />
            </a>
          </Box>
        </Box>
      </Box>
    );
  };
  return (
    <>
      <LayoutBottom>
        <Box className={classes.root}>
          <Box className={classes.leftPanel}>
            <SSOErrorMgs {...commonChildrenProps}></SSOErrorMgs>
          </Box>
          <Box className={classes.rightPanel}>
            <SignInImage {...commonChildrenProps} />
          </Box>
        </Box>
      </LayoutBottom>
    </>
  );
}

export default SignInSSOError;
